import React, { useState, useContext, useEffect } from "react";
import { FaFilter } from "react-icons/fa6";
import {
  BiSolidMessageRoundedAdd,
  BiSolidMessageRounded,
} from "react-icons/bi";

import { headToolsList } from "./head-tools-list";
import Modal from "../Modal";
import { MdGroupAdd, MdOutlineAddCircle } from "react-icons/md";
import { Link } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { SlOptions } from "react-icons/sl";
import { FaUser } from "react-icons/fa";
import { AuthContext } from "../../contexts/AuthContext";
import { WorkspaceContext } from "../../contexts/WorkspaceContext";
import Person from "../Person";
import { env } from "../../datas.config";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
import { joinRoomInbox } from "../../services/conversations";
import { CritereFiltreContext } from "../../contexts/CriteresFiltreContext";
import { socket } from "../../services/socket";

export default function HeadTools({ page }) {
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const workspaceId = currentWorkspace?._id;
  const { setCritereFiltre } = useContext(CritereFiltreContext);
  const {
    setDestinataire,
    setDisplayDiscussionForMiniScreen,
    conversations,
    setConversations,
    setActiveRoomIdInbox,
  } = useContext(DisplayDiscussionForMiniScreenContext);
  const [displayOpt, setDisplayOpt] = useState(false);
  const [display, setDisplay] = useState(false);
  const [displayModal, setDisplayModal] = useState("none");
  const [value, setValue] = useState("");
  const [searchUsers, setSearchUsers] = useState([]);
  const [visibleIndex, setVisibleIndex] = useState(null);
  const [criteres, setCriteres] = useState([]);

  const toggleOptionsList = (idx) => {
    if (visibleIndex === idx) {
      setVisibleIndex(null);
    } else {
      setVisibleIndex(idx);
    }
  };

  useEffect(() => {
    if (page === "Annonces") {
      setCriteres([
        {
          icon: headToolsList[0].icon,
          span: "Toutes les annonces",
        },
        {
          icon: headToolsList[1].icon,
          span: "Annonces non lues",
        },
      ]);
    } else {
      setCriteres(headToolsList);
    }
  }, [page]);

  const searchUser = () => {
    if (value.length >= 2 && !value.includes("#")) {
      fetch(`${env.domain}/api/auth/user/search/${value}`, {
        credentials: "include",
      })
        .then((res) => {
          return res.json();
        })
        .then((datas) => {
          console.clear();
          setSearchUsers(datas.users);
        })
        .catch((erreur) => {
          console.clear();
          console.error(erreur);
        });
    }
  };
  const afficheModal = () => {
    setDisplayModal("block");
    document.body.classList.add("modal-open");
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "0px";
  };

  return (
    <>
      <div className="tyn-aside-head-tools">
        <ul className="link-group gap gx-3">
          <li className="dropdown">
            {page === "Messages" ? (
              <>
                <button
                  className="link"
                  data-bs-toggle="modal"
                  data-bs-target="#newChat"
                  onClick={afficheModal}
                >
                  <BiSolidMessageRoundedAdd style={{ fontSize: "20px" }} />
                  <span>Nouveau</span>
                </button>
              </>
            ) : page === "Groupes" ? (
              <>
                <Link className="link" to="nouveau-groupe">
                  <MdGroupAdd style={{ fontSize: "20px" }} />
                  <span>Nouveau</span>
                </Link>
              </>
            ) : (
              <></>
            )}
          </li>
          <li className="dropdown">
            <button
              className="link dropdown-toggle"
              data-bs-toggle="dropdown"
              data-bs-offset="0,10"
              onClick={() => setDisplay(!display)}
            >
              <FaFilter style={{ fontSize: "20px" }} />
              <span>Filtrer</span>
            </button>
            <div
              className={`dropdown-menu dropdown-menu-end ${
                display
                  ? "show affiche-dropdown-menu-offcanvas-menu-filtrer animate__animated animate__fadeInUpBig animate__faster animate__reeat-1"
                  : ""
              }`}
            >
              <ul className="tyn-list-links nav nav-tabs border-0">
                {criteres.map((elem, idx) => (
                  <li key={idx}>
                    <button
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#all-chats"
                      onClick={() => setCritereFiltre(elem.span)}
                    >
                      {elem.icon}
                      <span>{elem.span}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        </ul>
      </div>
      {displayModal === "none" ? (
        <></>
      ) : (
        <Modal
          role={displayModal === "block" ? "dialog" : null}
          ariaModal={displayModal === "block" ? true : null}
          displayModal={displayModal}
          setDisplayModal={setDisplayModal}
        >
          <h4 className="pb-2">Procédez par recherche</h4>
          <div className="form-group">
            <div className="form-control-wrap">
              <div className="form-control-icon start">
                <BsSearch />
              </div>
              <input
                type="text"
                className="form-control form-control-solid"
                id="search-contact"
                placeholder="Recherche par nom, prénom..."
                value={value}
                onChange={(evt) => {
                  setValue(evt.target.value);
                  searchUser();
                }}
              />
            </div>
          </div>

          <ul className="tyn-media-list gap gap-3 pt-4">
            {searchUsers.map((userT, idx) => (
              <li key={idx}>
                <div className="tyn-media-group">
                  <div className="tyn-media">
                    <Person
                      person={{
                        image: userT.userImage,
                        nom: userT.nom,
                        prenom: userT.prenom,
                        userId: userT.userId,
                        colors: userT.color,
                      }}
                    />
                  </div>

                  <div className="tyn-media-col">
                    <div className="tyn-media-row">
                      <h6 className="name">{userT.prenom + " " + userT.nom}</h6>
                    </div>
                    <div className="tyn-media-row">
                      <p className="content">{userT.username}</p>
                    </div>
                  </div>
                  <button
                    className="btn btn-icon btn-white btn-pill dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-offset="0,0"
                    data-bs-auto-close="outside"
                    onClick={() => {
                      toggleOptionsList(idx);
                      setDisplayOpt(!displayOpt);
                    }}
                  >
                    <SlOptions />
                  </button>
                  {visibleIndex === idx && (
                    <ul className="tyn-media-option-list me-n1">
                      <li className="dropdown">
                        <div
                          className={`dropdown-menu dropdown-menu-end ${
                            displayOpt ? "show" : ""
                          }`}
                          style={{
                            position: "absolute",
                            inset: "0px 0px auto auto",
                            margin: "0px",
                            transform: "translate3d(0px, 40px, 0px)",
                          }}
                        >
                          <ul className="tyn-list-links">
                            <li>
                              <button
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  setConversations(!conversations);
                                  joinRoomInbox(user, userT, workspaceId);
                                  setDisplayDiscussionForMiniScreen(true);
                                  setDestinataire(userT);
                                  setActiveRoomIdInbox(
                                    user.userId > userT.userId
                                      ? `${user.userId}_${userT.userId}`
                                      : `${userT.userId}_${user.userId}`
                                  );
                                  socket.emit(
                                    "je_declare_tous_les_messages_inbox_de_cette_discussion_ouvert",
                                    {
                                      destinataire: user.userId,
                                      roomId:
                                        user.userId > userT.userId
                                          ? `${user.userId}_${userT.userId}`
                                          : `${userT.userId}_${user.userId}`,
                                      workspaceId,
                                    }
                                  );
                                  socket.emit(
                                    "vaChercherLaConversation",
                                    user.userId > userT.userId
                                      ? `${user.userId}_${userT.userId}`
                                      : `${userT.userId}_${user.userId}`,
                                    workspaceId
                                  );
                                  setDisplayModal("none");
                                }}
                              >
                                <BiSolidMessageRounded />
                                <span>Commencer à écrire</span>
                              </button>
                            </li>

                            <li>
                              <Link
                                data-bs-toggle="modal"
                                className="link"
                                to={`/contact/` + userT.username}
                              >
                                <FaUser />
                                <span>Voir le profil</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </Modal>
      )}
    </>
  );
}
